import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';
import jwt_decode from 'jwt-decode';
import { setToken } from '../../localStorage';
import { IInstitution } from '../../utils/interfaces/interfaces';
import { STATUS_CODES } from 'http';
// Define a type for the slice state
interface ISession {
  auth: string | null;
  user?: any;
  role: string | null;
  id: string | null;
  institutions: IInstitution[];
  isLoggedIn: boolean;
  isLoading: boolean;
}

interface IToken {
  role: string;
  sub: string;
}

// Define the initial state using that type
const initialState: ISession = {
  auth: null,
  role: null,
  user: null,
  id: null,
  institutions: [],
  isLoggedIn: false,
  isLoading: true
};

export const sessionSlice = createSlice({
  name: 'session',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    hydrate: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        auth: action.payload,
        role: localStorage.getItem('role'),
        id: localStorage.getItem('id')
      };
    },
    login: (state, action: PayloadAction<any>) => {
      localStorage.setItem('role', action.payload.role);
      localStorage.setItem('id', action.payload.id);

      setToken(action.payload.id);

      return {
        ...state,
        role: action.payload.role,
        auth: action.payload,
        id: action.payload.id
      };
    },
    updateUser: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        user: action.payload.user,
        institutions: action.payload.institutions
      };
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    logout: state => {
      console.log('---logging out---');
      localStorage.removeItem('role');
      localStorage.removeItem('id');
      localStorage.removeItem('jwt');
      localStorage.removeItem('rejwt');
      return {
        auth: null,
        user: null,
        role: null,
        id: null,
        institutions: [],
        isLoggedIn: false,
        isLoading: true
      };
    }
  }
});

export const {
  hydrate,
  logout,
  login,
  updateUser,
  setIsLoading,
  setIsLoggedIn
} = sessionSlice.actions;

export const session = (state: RootState) => state.session.auth;

export default sessionSlice.reducer;
